// extracted by mini-css-extract-plugin
export default {"root":"miliw","heading-and-subheading-block":"_3RwIm","headingAndSubheadingBlock":"_3RwIm","subheading":"_3byxL"};